import React, { VFC } from "react";
import { useTranslation } from "react-i18next";

import { WidgetsItemFinnAd as WidgetFinnAdProps } from "../../../types";
import constants from "../../_globalStyles/constants";
import { truncateText, pxToRem, pxToEm } from "../../../util/helpers";
import Box from "../../particles/Box";
import Text from "../../atoms/Text";
import {
  FinnAdLink,
  FinnAdTile,
  FinnAdLogo,
  FinnAdMedia,
  FinnAdImageLoader,
  FinnAdPlayIcon,
  FinnAdMediaIcon,
  FinnAdContentBox,
} from "./styled";

const WidgetFinnAd: VFC<WidgetFinnAdProps> = ({
  link,
  displayLogo,
  logo,
  customerName,
  mileage,
  price,
  description,
  media,
  mediaType,
  title,
  titleAs,
}) => {
  const { t } = useTranslation();
  const formattedPrice = price ? `${Number(price)?.toLocaleString('nb-NO')},-` : '';
  const formattedMileage = mileage ? `${mileage.toLocaleString('nb-NO')} km` : '';

  return (
    <FinnAdTile as="article" border={false}>
      <FinnAdMedia media={media}>
        {media && (
          <>
            <FinnAdImageLoader />
            {mediaType === "video" && <FinnAdPlayIcon />}
          </>
        )}
        {!media && <FinnAdMediaIcon name="no-image" />}
      </FinnAdMedia>
      <FinnAdContentBox
        paddingV={1}
        paddingH={1.875}
        overflowHidden
      >
        <Text
          as={titleAs}
          bold
          fontSize={pxToRem(20)}
          lineHeight="1.3"
          clip={1}
        >
          {title}
        </Text>

        <Text
          as="p"
          fontSize={pxToRem(16)}
          lineHeight={pxToEm(20, 16)}
          clip={2}
          color={constants.COLOR_GRAY_450}
        >
          {truncateText(description ?? "", 50)}
        </Text>

        <Box flex alignCenter justifySpaceBetween>
          <Text
            as="p"
            bold
            fontSize={pxToRem(28)}
            lineHeight="1.2"
            clip={1}
            color={constants.COLOR_GRAY_450}
          >
            {formattedPrice}
          </Text>

          <Text
            as="p"
            fontSize={pxToRem(16)}
            lineHeight="1.2"
            clip={1}
            color={constants.COLOR_GRAY_700}
          >
            {formattedMileage}
          </Text>
        </Box>

        <Box flex alignCenter marginT={'auto'}>
          {displayLogo && (
            <Box inlineFlex flexStatic marginR={1.5}>
              <FinnAdLogo src={logo} alt="" />
            </Box>
          )}
          <Text
            fontSize={pxToRem(14)}
            lineHeight={"1.2"}
            color={constants.COLOR_GRAY_500}
            clip={2}
          >
            {truncateText(customerName, 30)}
          </Text>
        </Box>
      </FinnAdContentBox>
      <FinnAdLink href={link || "#"} target="_blank" rel="noopener noreferrer">
        <span className="ddb-visually-hidden">{`FinnAd: '${truncateText(
          title ?? "",
          10
        )}' ${t("accessibility.new_tab")}`}</span>
      </FinnAdLink>
    </FinnAdTile>
  );
};

WidgetFinnAd.defaultProps = {
  titleAs: "h4",
};

export default WidgetFinnAd;
